<div class="card mb-5">
  <div class="card-header" *ngIf="data?.chartConfig?.showInnerTitle === false || data?.showCardHeader === true">
    <div class="card-title d-flex flex-column">
      <h4>{{ data?.title || 'Stacked Line' }}</h4>
    </div>
  </div>
  <div class="card-body">
    <div
      [id]="data?.widgetId"
      [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'"
      class="stacked-line-chart-host"
    ></div>
  </div>
</div>
